// AlignUI SparkLineChart v0.0.0

import { Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';

type SparkLineChartProps<T extends string> = {
  data: { [key in T]: number | string }[];
  index: T;
  category: T;
  /**
   * Высота полоски. У AlignUI зашита в 40 — столько занимает линия в плитке показателя.
   * Вынесена наружу, потому что та же линия стоит и в блоке шириной во весь экран, где
   * сорока точек мало, чтобы разглядеть перелом.
   */
  height?: number;
};

const SparkLineChart = <T extends string>({
  data,
  index,
  category,
  height = 40,
}: SparkLineChartProps<T>) => {
  return (
    <ResponsiveContainer width='100%' height={height}>
      <LineChart data={data} margin={{ top: 1, right: 0, bottom: 1, left: 0 }}>
        <XAxis dataKey={index} hide />
        <YAxis hide />
        <Line
          type='monotone'
          dataKey={category}
          className='text-primary-base'
          stroke='currentColor'
          strokeWidth={2}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default SparkLineChart;
